import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IGroupSpaceItem } from "../../group-spaces";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalFilterToIRI } from "../../utils/filters";
import { IGroupMessageResource } from "../types";

export interface IGroupMessageCreateMutationParameters {
    groupSpace: RelationalValue<IGroupSpaceItem>;
    message: string;
}

export type IGroupMessageCreateMutationResult = IGroupMessageResource;

export const groupMessageCreateMutation: IApiMutationFunction<IGroupMessageCreateMutationParameters> = ({
    groupSpace,
    message,
}) => {
    return {
        method: "POST",
        url: `/group_messages`,
        data: {
            groupSpace: mapRelationalFilterToIRI(EntityTypes.GROUP_SPACE, groupSpace),
            message,
            uuid: uuid(),
        },
    };
};

export const useGroupMessageCreateMutation = createApiMutationHook<
    IGroupMessageCreateMutationParameters,
    IGroupMessageCreateMutationResult
>(groupMessageCreateMutation);
